
import { Component, Vue, Emit, Prop, Watch } from "vue-property-decorator";
import { ServerTableDetails } from "@/store/devices/types";
import { PaginatedSearchQueryParams } from "@/store/types";
import GenericTable, { TableHeader } from '../table/generic-table.vue';
import { AlarmPointsResponse } from "@/store/alarm-points/types";
import { formatDateMixin } from "@/mixins";
import { Getter } from 'vuex-class';

const { convertUtcDateTimeToLocalDateTime } = formatDateMixin.methods;

@Component({
  components: {
    "generic-table": GenericTable
  }
})

export default class AlarmPointsTable extends Vue {
  // Props
  @Prop({ type: Array }) public alarmsList: AlarmPointsResponse[];
  @Prop({ type: Number }) public totalAlarmCount: number;
  @Prop({ type: Boolean, default: true, required: false }) showTableSearch: boolean;
  @Prop({ type: String, default: null, required: false }) private searchQuery: string;
  @Prop({ type: Boolean, default: false }) public isLoading: boolean;

  // Vuex
  @Getter("getFeature") getFeature: (featureName: string[]) => boolean;

  private mounted(): void {
    if (this.isMaskReasonFeatureEnabled) {
      this.columns.push(
        {
          title: "Mask Reason",
          key: "disarmReasonTitle",
          order: 4,
          sortOrder: 1,
          sortOrderReversed: false,
          description: "Masked",
          searchable: false,
          visible: true,
          dataType: "string",
          isTermLabel: false,
          sortable: false,
        }
      )
    }

    if (this.isMaskingEnabled) {
      this.columns.push(
        {
          title: "Masked",
          key: "maskedUntilColumnText",
          order: 3,
          sortOrder: 1,
          sortOrderReversed: false,
          description: "Masked",
          searchable: false,
          visible: true,
          dataType: "string",
          isTermLabel: false,
          sortable: false,
        }
      )
    }
  }

  private columns: TableHeader[] = [
		{
			title: "Title",
			key: "title",
			order: 1,
			sortOrder: 0,
			sortOrderReversed: false,
			description: "Device Name",
			searchable: true,
			visible: true,
			dataType: "string",
			isTermLabel: true,
			sortable: true,
			isSortedByDefault: true,
    },
    {
      title: "On Test",
      key: "onTestUntilColumnText",
      order: 2,
      sortOrder: 1,
      sortOrderReversed: false,
      description: "On Test",
      searchable: false,
      visible: true,
      dataType: "string",
      isTermLabel: false,
      sortable: false,
    },
  ]

  private get isMaskReasonFeatureEnabled(): boolean { 
		return this.getFeature(["Alarms", "Masking", "Advanced", "Reasons"]);
  } 

  private get isMaskingEnabled(): boolean {
    return this.getFeature(["Alarms", "Masking"]);
  }

  private get records(): AlarmPointsResponse[] {
    if (!this.alarmsList) { 
      return []; 
    }

    return this.alarmsList.map(alarm => {
      if (alarm.onTestUntil) {
        alarm.onTestUntilColumnText = "On Test Until: " + convertUtcDateTimeToLocalDateTime(alarm.onTestUntil);
      } else {
        alarm.onTestUntilColumnText = "";
      }

      if (!alarm.armed && alarm.toggleArmAt) {
        alarm.maskedUntilColumnText = "Masked Until: " + convertUtcDateTimeToLocalDateTime(alarm.toggleArmAt);
      } else {
        alarm.maskedUntilColumnText = "";
      }

      return alarm;
    });
  }

  @Emit("openOnTest")
  private openOnTest(selectedRow: ServerTableDetails): ServerTableDetails {
    return selectedRow;
  }

  @Emit("fetchAlarms")
  public async updateData(paginatedSearchQueryParams?: PaginatedSearchQueryParams): Promise<PaginatedSearchQueryParams> {
    return paginatedSearchQueryParams;
  }
}
